import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { SessionStoreRepository } from '../../shared/repositories/session.repository';
import { SchemaRepository } from '../../shared/repositories/schema.repository';
import { ConsentStoreRepository } from '../../shared/repositories/consent.repository';

@Component({
    selector: 'web-patient-logged-out',
    imports: [TranslocoDirective],
    templateUrl: './logged-out.component.html',
    styleUrl: './logged-out.component.scss'
})

export class LoggedOutComponent implements OnInit {
    private readonly sessionService = inject(SessionStoreRepository);
    private readonly schemaRepository = inject(SchemaRepository);
    private readonly consentStore = inject(ConsentStoreRepository)
    private readonly router = inject(Router);

    public ngOnInit() {
        this.sessionService.resetStores();
        this.schemaRepository.resetStores();
        this.consentStore.clearConsentStore();
    }

    onLoginClick() {
        this.router.navigate(["/auth/login"]);
    }

    onHomeClick() {
        this.router.navigate(["/welcome"]);
    }
}